import { createContext } from "react";

import { type EnvironmentInfo } from "helpers/AppProvider.types";

/**
 * Context containing information about the current app environment (dev/test/prod)
 * and other global/envrionment states
 */
export const EnvironmentInfoContext = createContext<EnvironmentInfo | undefined>(undefined);
